import React from 'react';

import { Progress } from '@/components/ui/progress';

export interface ACOverviewProgressLegend {
  label: string;
  color: string;
}

interface ACOverviewProgressCardProps {
  legends: ACOverviewProgressLegend[];
  displayValue: string;
  progressValue: number;
  fillColor: string;
}

const ACOverviewProgressCard: React.FC<ACOverviewProgressCardProps> = ({
  legends,
  displayValue,
  progressValue,
  fillColor
}) => (
  <div className="bg-white rounded-[16px] border border-lightGray p-4">
    <div className="flex items-start justify-between gap-4 mb-3">
      <div className="flex flex-col gap-1.5 min-w-0">
        {legends.map((legend) => (
          <div key={legend.label} className="flex items-center gap-2">
            <span className="size-2 rounded-full shrink-0" style={{ backgroundColor: legend.color }} />
            <span className="text-xs font-medium text-gray">{legend.label}</span>
          </div>
        ))}
      </div>
      <span className="text-[28px] font-bold text-gray leading-none shrink-0">{displayValue}</span>
    </div>
    <Progress
      value={progressValue}
      className="h-4 rounded-[4px] bg-primary"
      indicatorClassName="rounded-[4px]"
      indicatorStyle={{ backgroundColor: fillColor }}
    />
  </div>
);

export default ACOverviewProgressCard;
